import React from 'react'
import { CSSTransitionGroup } from 'react-transition-group'

import './css/index.css'  

const Overlay = () => (
  <CSSTransitionGroup
    transitionName="fade"
    transitionAppear={true}
    transitionAppearTimeout={500}
    transitionLeaveTimeout={500}
    transitionEnter={false}
    transitionLeave={true}>
    <div id="overlay" className="overlay" />
  </CSSTransitionGroup>  
)

export default Overlay



// WEBPACK FOOTER //
// src/Overlay.js